import { render, staticRenderFns } from "./StudentCourses.vue?vue&type=template&id=31fb011a&"
import script from "./StudentCourses.vue?vue&type=script&lang=js&"
export * from "./StudentCourses.vue?vue&type=script&lang=js&"
import style0 from "./StudentCourses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports